import "./VehiclesDetailsContent.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useMemo } from "react";
import { useState } from "react";

import VehiclesDetailsImage from "../VehiclesDetailsImage/VehiclesDetailsImage";

import { fetchVehiclesDetails } from "../../../../../slices/vehiclesDetailsSlice";

const getImageSrc = (img) => {
    if (!img) return null;

    if (typeof img === "string") {
        return img;
    }

    return (
        img.url ||
        img.path ||
        img.image_path ||
        img.image ||
        img.src ||
        null
    );
};

const VehiclesDetailsContent = ({ id }) => {
    const columns = useSelector((state) => state.vehiclesDetails.columns);
    const data = useSelector((state) => state.vehiclesDetails.data);
    const images = useSelector((state) => state.vehiclesDetails.images);

    const normalizedImages = useMemo(() => {
        return (images || [])
            .map((img) => ({
                original: img,
                src: getImageSrc(img),
            }))
            .filter((img) => Boolean(img.src));
    }, [images]);

    const [previewImages, setPreviewImages] = useState([]);
    const [previewIndex, setPreviewIndex] = useState(0);

    return (
        <>
            <div className="vehicles-details-content">
                <div className="vehicles-details-content_container">
                    {columns.map((col) => {
                        const value = data?.attributes?.[col.key];
                        const isImageColumn = col.key === "image_path";

                        return (
                            <div key={col.key} className="vehicles-details-content_field">
                                <div className="vehicles-details-content_title">
                                    {col.alias || col.name}
                                </div>

                                <div className="vehicles-details-content_description">
                                    {isImageColumn && normalizedImages.length ? (
                                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                            {normalizedImages.map((img, i) => (
                                                <img
                                                    key={`${i}-${img.src}`}
                                                    src={img.src}
                                                    alt={`vehicle-${i}`}
                                                    style={{
                                                        width: 140,
                                                        height: 140,
                                                        objectFit: "cover",
                                                        borderRadius: 7,
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                        setPreviewIndex(i);
                                                        setPreviewImages(normalizedImages);
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    ) : (
                                        value || "-"
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {previewImages.length > 0 && (
                <VehiclesDetailsImage
                    previewImages={previewImages}
                    index={previewIndex}
                    setIndex={setPreviewIndex}
                    onClose={() => setPreviewImages([])}
                />
            )}
        </>
    );
};

export default VehiclesDetailsContent;